import { cn as e } from "../../lib/utils.es.js";
import { getEmbedPortalContainer as t } from "../../lib/embed-portal-container.es.js";
import "react";
import { CheckIcon as n, ChevronDownIcon as r, ChevronUpIcon as i } from "lucide-react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import * as s from "@radix-ui/react-select";
// libs/ui-lib/src/components/ui/select.tsx
function c({ ...e }) {
	return /* @__PURE__ */ a(s.Root, {
		"data-slot": "select",
		...e
	});
}
function l({ ...e }) {
	return /* @__PURE__ */ a(s.Group, {
		"data-slot": "select-group",
		...e
	});
}
function u({ ...e }) {
	return /* @__PURE__ */ a(s.Value, {
		"data-slot": "select-value",
		...e
	});
}
function d({ className: t, size: n = "default", children: i, ...c }) {
	return /* @__PURE__ */ o(s.Trigger, {
		"data-slot": "select-trigger",
		"data-size": n,
		className: e("border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", t),
		...c,
		children: [i, /* @__PURE__ */ a(s.Icon, {
			asChild: !0,
			children: /* @__PURE__ */ a(r, { className: "size-4 opacity-50" })
		})]
	});
}
function f({ className: n, children: r, position: i = "popper", ...c }) {
	return /* @__PURE__ */ a(s.Portal, {
		container: t() ?? void 0,
		children: /* @__PURE__ */ o(s.Content, {
			"data-slot": "select-content",
			className: e("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border border-border shadow-md", i === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", n),
			position: i,
			...c,
			children: [
				/* @__PURE__ */ a(g, {}),
				/* @__PURE__ */ a(s.Viewport, {
					className: e("p-1", i === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
					children: r
				}),
				/* @__PURE__ */ a(_, {})
			]
		})
	});
}
function p({ className: t, ...n }) {
	return /* @__PURE__ */ a(s.Label, {
		"data-slot": "select-label",
		className: e("text-muted-foreground px-2 py-1.5 text-xs", t),
		...n
	});
}
function m({ className: t, children: r, ...i }) {
	return /* @__PURE__ */ o(s.Item, {
		"data-slot": "select-item",
		className: e("focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", t),
		...i,
		children: [/* @__PURE__ */ a("span", {
			className: "absolute right-2 flex size-3.5 items-center justify-center",
			children: /* @__PURE__ */ a(s.ItemIndicator, { children: /* @__PURE__ */ a(n, { className: "size-4" }) })
		}), /* @__PURE__ */ a(s.ItemText, { children: r })]
	});
}
function h({ className: t, ...n }) {
	return /* @__PURE__ */ a(s.Separator, {
		"data-slot": "select-separator",
		className: e("bg-border pointer-events-none -mx-1 my-1 h-px", t),
		...n
	});
}
function g({ className: t, ...n }) {
	return /* @__PURE__ */ a(s.ScrollUpButton, {
		"data-slot": "select-scroll-up-button",
		className: e("flex cursor-default items-center justify-center py-1", t),
		...n,
		children: /* @__PURE__ */ a(i, { className: "size-4" })
	});
}
function _({ className: t, ...n }) {
	return /* @__PURE__ */ a(s.ScrollDownButton, {
		"data-slot": "select-scroll-down-button",
		className: e("flex cursor-default items-center justify-center py-1", t),
		...n,
		children: /* @__PURE__ */ a(r, { className: "size-4" })
	});
}
export { c as Select, f as SelectContent, l as SelectGroup, m as SelectItem, p as SelectLabel, _ as SelectScrollDownButton, g as SelectScrollUpButton, h as SelectSeparator, d as SelectTrigger, u as SelectValue };
